import { render, staticRenderFns } from "./refundRecord.vue?vue&type=template&id=6b926216&scoped=true&"
import script from "./refundRecord.vue?vue&type=script&lang=js&"
export * from "./refundRecord.vue?vue&type=script&lang=js&"
import style0 from "./refundRecord.vue?vue&type=style&index=0&id=6b926216&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b926216",
  null
  
)

export default component.exports